import { useNavigate, useParams } from 'react-router-dom';

import { Loading } from 'components';
import usingStorage from 'app/utils/storage';
import { useEffect } from 'react';
import { createUrl } from 'app/utils';

const storage = usingStorage('localStorage');

const Current = () => {
  const { dashboardUuid } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    storage.set('currentDashboard', dashboardUuid);

    navigate(createUrl('dashboard'));
  }, [dashboardUuid]);

  return <Loading label="Por favor, aguarde." />;
};

export default Current;
